import { Icons } from '@components/Icons/Icons';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import type { ReactElement } from 'react';

export function SocialLinks({
  name,
  noFollow,
  facebook,
  instagram,
  twitter,
  tiktok,
  linkedIn,
  website,
  youTube,
}: {
  name: string;
  noFollow: boolean;
  facebook?: string;
  instagram?: string;
  twitter?: string;
  tiktok?: string;
  linkedIn?: string;
  website?: string;
  youTube?: string;
}): ReactElement {
  let rel = '';
  // do not allow follow all social links if noFollow is selected in Sanity
  if (noFollow) {
    rel = 'nofollow';
  }

  return (
    <p className="mx-0 mb-5 mt-2.5 flex justify-center gap-2.5">
      {facebook && (
        <TextLink href={facebook} rel={rel}>
          <Icons.Social.Facebook.Standard
            role="img"
            aria-label={`${name} facebook`}
            size={24}
          />
        </TextLink>
      )}
      {instagram && (
        <TextLink href={instagram} rel={rel}>
          <Icons.Social.Instagram
            role="img"
            aria-label={`${name} instagram`}
            size={24}
          />
        </TextLink>
      )}
      {twitter && (
        <TextLink href={twitter} rel={rel}>
          <Icons.Social.XTwitter
            role="img"
            aria-label={`${name} twitter`}
            size={24}
          />
        </TextLink>
      )}
      {tiktok && (
        <TextLink href={tiktok} rel={rel}>
          <Icons.Social.Tiktok
            role="img"
            aria-label={`${name} tiktok`}
            size={24}
          />
        </TextLink>
      )}
      {youTube && (
        <TextLink href={youTube} rel={rel}>
          <Icons.Social.Youtube
            role="img"
            aria-label={`${name} youtube`}
            size={24}
          />
        </TextLink>
      )}
      {linkedIn && (
        <TextLink href={linkedIn} rel={rel}>
          <Icons.Social.LinkedIn
            role="img"
            aria-label={`${name} linked in`}
            size={24}
          />
        </TextLink>
      )}
      {website && (
        <TextLink href={website} rel={rel}>
          <Icons.Social.Website
            role="img"
            aria-label={`${name} website`}
            size={24}
          />
        </TextLink>
      )}
    </p>
  );
}
